// src/lib/menage-run-restitution.js — LOT Photos ménage 27
//
// Helpers PURS (sans I/O) pour la restitution admin LECTURE SEULE d'un
// menage_run dans la fiche résa (MenageTab). Extraits ici pour être
// unit-testables sans rendre le composant (qui fetch supabase + endpoint).
//
// Shapes de référence (cf. ChecklistRunModal / menage-photo-queue) :
//   - photo        : { piece_id, url, uploaded_at }
//   - pieces (cfg) : [{ id, icon, name, photos_min, items: [{ id, label }] }]
//   - items_checked: { [pieceId]: [itemId, ...] }  (JSONB du run)

/**
 * Regroupe les photos d'un run par piece_id, en préservant l'ordre
 * d'apparition. Réutilisé côté ménage (ChecklistRunModal) et côté admin
 * (MenageTab restitution).
 *
 * @param {Array<{piece_id:string, url:string, uploaded_at?:string}>} photos
 * @returns {Object<string, Array>} map piece_id -> [photos]
 */
export function groupPhotosByPiece(photos) {
  const map = {}
  ;(Array.isArray(photos) ? photos : []).forEach(p => {
    if (!p) return
    const key = p.piece_id || '__sans_piece__'
    if (!map[key]) map[key] = []
    map[key].push(p)
  })
  return map
}

/**
 * Construit le détail des items cochés groupés par pièce, en résolvant
 * chaque item.id vers son label via la config `pieces` (info.menage.pieces).
 *
 * Robustesse (config peut avoir changé depuis l'exécution du run) :
 *   - pièce absente de la config → `pieceKnown:false`, on garde le compteur
 *     brut + on liste les ids cochés sans label (fallback id).
 *   - item absent de la pièce → `label:null` (le rendu affiche l'id brut).
 *
 * @param {Object<string, Array<string>>} itemsChecked  run.items_checked
 * @param {Array} pieces  info.menage.pieces (peut être null/[])
 * @returns {Array<{
 *   pieceId:string, pieceName:string|null, pieceIcon:string|null,
 *   pieceKnown:boolean, checkedCount:number,
 *   items:Array<{id:string, label:string|null}>
 * }>}
 */
export function buildItemsCheckedDetail(itemsChecked, pieces) {
  const checked = itemsChecked && typeof itemsChecked === 'object' ? itemsChecked : {}
  const piecesList = Array.isArray(pieces) ? pieces : []
  const pieceById = {}
  piecesList.forEach(p => { if (p && p.id) pieceById[p.id] = p })

  return Object.keys(checked).map(pieceId => {
    const ids = Array.isArray(checked[pieceId]) ? checked[pieceId] : []
    const piece = pieceById[pieceId] || null
    const itemById = {}
    if (piece && Array.isArray(piece.items)) {
      piece.items.forEach(it => { if (it && it.id) itemById[it.id] = it })
    }
    return {
      pieceId,
      pieceName: piece ? (piece.name || null) : null,
      pieceIcon: piece ? (piece.icon || null) : null,
      pieceKnown: !!piece,
      checkedCount: ids.length,
      items: ids.map(id => ({
        id,
        label: itemById[id] ? (itemById[id].label || null) : null,
      })),
    }
  })
}
